exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content{min-height:100%;position:relative;margin-bottom:100px}.flex-column{-ms-flex-direction:column!important;flex-direction:column!important}.footer{width:100%;position:absolute;bottom:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-42be46cf","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Traker.vue
// module id = 516
// module chunks = 0